// Per-route <title> and <meta name="description"> for a client-rendered page.
//
// The static pages (About, Programs, Project) each inline their own copy of
// this querySelector/createElement dance. The legal pages need the same two
// tags, so the logic lives here rather than being pasted a fourth and fifth
// time. Those older pages are left alone -- migrating them is not part of
// adding /privacy and /terms.

export function setPageMeta(title, description) {
    document.title = title;
    if (!description) return;
    let el = document.querySelector('meta[name="description"]');
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', 'description');
        document.head.appendChild(el);
    }
    el.content = description;
}
